import React, { useEffect, useState, useRef, CSSProperties } from "react";

// Utils
import { base64ToObjectURL, isIOS } from "react-lib/utils/printURL";

// Types
type CardPrintListPdfViewerProps = {
  file: string | null;
};

// Styles
const styles: Record<string, CSSProperties> = {
  placeholder: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iosContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  iosButton: {
    padding: "12px 24px",
    backgroundColor: "#2185d0",
    color: "white",
    borderRadius: "6px",
    textDecoration: "none",
    fontSize: "16px",
    fontWeight: "bold",
  },
  embed: {
    width: "100%",
    height: "100%",
    border: "none",
  },
};

const CardPrintListPdfViewer: React.FC<CardPrintListPdfViewerProps> = ({ file }) => {
  const [objUrl, setObjUrl] = useState<string | null>(null);
  const prevUrlRef = useRef<string | null>(null);
  const ios = isIOS();

  useEffect(() => {
    // cleanup previous object url
    if (prevUrlRef.current) {
      URL.revokeObjectURL(prevUrlRef.current);
      prevUrlRef.current = null;
    }

    if (!file) {
      setObjUrl(null);
      return;
    }

    if (file === "about:blank") {
      setObjUrl("about:blank");
      return;
    }

    // base64 -> Blob URL (for support IOS)
    if (file.startsWith("data:application/pdf;base64,")) {
      const url = base64ToObjectURL(file);
      prevUrlRef.current = url;
      setObjUrl(url);
    } else {
      setObjUrl(file);
    }

    return () => {
      if (prevUrlRef.current) {
        URL.revokeObjectURL(prevUrlRef.current);
      }
    };
  }, [file]);

  if (!objUrl) {
    return (
      <div style={styles.placeholder}>
        <p style={{ color: "#999" }}>กรุณาเลือกเอกสารที่ต้องการแสดง</p>
      </div>
    );
  }

  // IOS
  if (ios) {
    return (
      <div style={styles.iosContainer}>
        <a
          href={objUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={styles.iosButton}
        >
          Open PDF in a new tab
        </a>
      </div>
    );
  }

  // Desktop
    return (
      <embed
        src={objUrl}
        type="application/pdf"
        style={styles.embed}
      />
    );
};

export default CardPrintListPdfViewer;